export default ({ fill }) => (
  /**
   * Ícone utilizado para ativação de negrito
   * na fonte dos rótulos
   */
  <svg
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.1724 15.3867H10.0818L4.06527 5.51721V15.3867H0.974609V0.386719H4.06527L10.0921 10.2768V0.386719H13.1724V15.3867Z"
      fill={fill || '#797E82'}
    />
  </svg>
);
